import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { AuthService } from '../../../services/auth.service';
import { ModalStartScreenComponent } from '../modal-start-screen/modal-start-screen.component';
import { ProjectManagerService } from '../../../services/project-manager.service';
import { ModalSaveComponent } from '../modal-save/modal-save.component';
import { ToasterService } from 'angular2-toaster';
import { LoadingSpinnerService } from '../../../services/loading-spinner.service';
import { SalesDashboardService } from '../../../services/sales-dashboard.service';
import { environment } from '../../../../environments/environment';
// import { AnalyticsService } from '../../../services/analytics.service';
import {PdfService} from '../../../services/pdf.service';

@Component({
  selector: 'app-modal-print',
  templateUrl: './modal-print.component.html',
  styleUrls: ['./modal-print.component.scss']
})
export class ModalPrintComponent implements OnInit {
  appUrl: string = environment.appUrl;

  url_project: string;

  shareForm: any = {
    receiverEmail: '',
    senderEmail: '',
    subject: 'Feeney Railing Design'
  };

  isAuthorization: boolean = false;
  isSaved: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModalPrintComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public auth: AuthService,
    public projectSrvc: ProjectManagerService,
    private toasterService: ToasterService,
    private loadingSpinnerService: LoadingSpinnerService,
    private salesDashboardService: SalesDashboardService,
    // private analyticsService: AnalyticsService,
    private pdfService: PdfService,
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }

  login() {
    // this.dialogRef.close();

    let dialogRef = this.dialog.open(ModalStartScreenComponent, {
      width: '835px',
      height: '75vh',
      data: 'login-for-print'
    });

    dialogRef.afterClosed().subscribe(result => {
      //
    });
  }

  saveProject() {
    // this.dialogRef.close();

    let dialogRef = this.dialog.open(ModalSaveComponent, {
      width: '455px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Save/Rename dialog was closed');
      // print();
    });
  }

  print() {
    this.pdfService.printProject();
    this.dialogRef.close();
  }

  ngOnInit() {
    // console.log(this.data);

    let projectFromSalesDashboardId = this.salesDashboardService.getSelectedProjectId();

    this.auth.isAuthorization.subscribe(auth => (this.isAuthorization = auth));
    this.projectSrvc.isSavedProject.subscribe(value => {
      this.isSaved = value;
      if (projectFromSalesDashboardId) {
        this.data = 'printProject';
        this.isSaved = true;
        this.url_project = `${this.appUrl}/browsing/` + projectFromSalesDashboardId;
        this.salesDashboardService.clearSelectedProjId();
      } else if (this.isSaved == true) {
        this.url_project = `${this.appUrl}/browsing/` + this.projectSrvc.getCurrentProjectId();
        // this.url_project = 'http://localhost:4200/browsing/' + this.projectSrvc.getCurrentProjectId();
      }
      // console.log(this.isSaved)
    });
  }

  showToast(type: string, title: string, body: string): void {
    this.toasterService.popAsync(type, title, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-print/modal-print.component.ts